import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _get from "lodash/get";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";

function responseDataParser(data) {
  return _get(data, 'data');
}

function responseHandler(resolve, reject, options, serverRequest) {
  var dataParser = _get(options, 'dataParser', responseDataParser);

  return function (err, resp, data) {
    var statusCode = !err && _get(resp, 'statusCode');

    if (!err && statusCode >= 200 && statusCode < 300) {
      resolve(dataParser(data, resp));
    } else {
      // This is super raw, but until we form stronger opinions about how we handle errors on
      // the FE, this is the most flexible solution.
      if (typeof window === 'undefined' && serverRequest && _get(resp, 'statusCode') >= 500) {
        var method = _get(resp, 'request.method');

        var href = _get(resp, 'request.href');

        serverRequest.log.error("".concat(method, " ").concat(href, " returned a ").concat(_get(resp, 'statusCode')));
      }

      reject({
        err: err,
        resp: resp,
        data: data
      });
    }
  };
}

export default function (ServiceSDK, routeBuilder, handlerOptions) {
  return {
    get: function get(endpoint, params, serverRequest, config) {
      return new Promise(function (resolve, reject) {
        ServiceSDK.get(routeBuilder(endpoint), params, responseHandler(resolve, reject, _objectSpread(_objectSpread({}, handlerOptions), config), serverRequest), serverRequest, config);
      });
    },
    post: function post(endpoint, data, serverRequest, config) {
      return new Promise(function (resolve, reject) {
        ServiceSDK.post(routeBuilder(endpoint), data, responseHandler(resolve, reject, _objectSpread(_objectSpread({}, handlerOptions), config), serverRequest), serverRequest, config);
      });
    },
    put: function put(endpoint, data, serverRequest, config) {
      return new Promise(function (resolve, reject) {
        ServiceSDK.put(routeBuilder(endpoint), data, responseHandler(resolve, reject, _objectSpread(_objectSpread({}, handlerOptions), config), serverRequest), serverRequest, config);
      });
    },
    patch: function patch(endpoint, data, serverRequest, config) {
      return new Promise(function (resolve, reject) {
        ServiceSDK.patch(routeBuilder(endpoint), data, responseHandler(resolve, reject, _objectSpread(_objectSpread({}, handlerOptions), config), serverRequest), serverRequest, config);
      });
    },
    delete: function _delete(endpoint, data, serverRequest, config) {
      return new Promise(function (resolve, reject) {
        ServiceSDK.del(routeBuilder(endpoint), data, responseHandler(resolve, reject, _objectSpread(_objectSpread({}, handlerOptions), config), serverRequest), serverRequest, config);
      });
    }
  };
}